export default function ServicesSection() {
  const scrollToTrialPlan = () => {
    const element = document.getElementById('plans');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToCommitPlan = () => {
    const element = document.getElementById('plans');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // 少し遅延させてから安心コミットプランまでスクロール
      setTimeout(() => {
        const commitPlan = element.querySelector('.border-\\[\\#66BB6A\\]');
        if (commitPlan) {
          commitPlan.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    }
  };

  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-[#FAF0E6] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-20 space-y-4 sm:space-y-6">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">サービス内容</h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#757575] max-w-3xl mx-auto">
            あなたに合ったプランで、無理なく続けられるサポートを
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-2xl transition-all border-2 border-[#E8F5E9]">
            <div className="space-y-4 sm:space-y-6">
              <div className="inline-block bg-[#E8F5E9] text-[#66BB6A] px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-medium">
                初めての方におすすめ
              </div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#2C2C2C]">お試しサポートプラン</h3>
              <div className="flex items-baseline gap-2">
                <span className="text-4xl sm:text-5xl font-bold text-[#66BB6A]">¥3,900</span>
                <span className="text-base sm:text-lg text-[#757575]">/ 月(税込)</span>
              </div>
              <div className="space-y-3 sm:space-y-4 pt-4 sm:pt-6 border-t border-gray-200">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-[#2C2C2C]">月３時間までの対面またはオンライン相談</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-[#2C2C2C]">SNSなどの投稿計画サポート</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-[#2C2C2C]">習得したいツールのサポート</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-[#2C2C2C]">CanvaやAIの基本レッスン</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-[#2C2C2C]">オーナー様向け共有レポート</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-xl sm:text-2xl text-[#66BB6A] flex-shrink-0 mt-1"></i>
                  <span className="text-xs sm:text-sm text-[#757575]">※その他ご希望の内容により計画ご提案いたします。</span>
                </div>
              </div>
              <button 
                onClick={scrollToTrialPlan}
                className="w-full bg-[#66BB6A] text-white py-3 sm:py-4 rounded-full hover:bg-[#4CAF50] transition-all font-medium text-sm sm:text-base whitespace-nowrap cursor-pointer">
                このプランの詳細
              </button>
            </div>
          </div>
          <div className="bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl hover:shadow-3xl transition-all relative overflow-hidden">
            <div className="absolute top-4 right-4 sm:top-6 sm:right-6 bg-white text-[#66BB6A] px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-bold">
              人気No.1
            </div>
            <div className="space-y-4 sm:space-y-6 relative z-10">
              <div className="inline-block bg-white/20 text-white px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-medium">
                しっかりサポート
              </div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">安心コミットプラン</h3>
              <div className="flex items-baseline gap-2">
                <span className="text-4xl sm:text-5xl font-bold text-white">¥5,800</span>
                <span className="text-base sm:text-lg text-white/90">/ 月(税込)</span>
              </div>
              <div className="space-y-3 sm:space-y-4 pt-4 sm:pt-6 border-t border-white/30">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-white flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-white">月３時間までの対面またはオンライン相談</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-white flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-white"><strong>LINE(チャット)質問し放題</strong>(月〜金)</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-white flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-white">投稿計画・添削・アドバイス</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-white flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-white">Canva や AI の応用レッスン</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-xl sm:text-2xl text-white flex-shrink-0 mt-1"></i>
                  <span className="text-sm sm:text-base text-white">オーナー向け共有レポート</span>
                </div>
              </div>
              <button 
                onClick={scrollToCommitPlan}
                className="w-full bg-white text-[#66BB6A] py-3 sm:py-4 rounded-full hover:bg-gray-50 transition-all font-bold text-sm sm:text-base whitespace-nowrap cursor-pointer">
                このプランの詳細
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
